import React, { useState, useEffect } from 'react';
import socket from './socket';
import Lobby from './components/Lobby';
import Game from './components/Game';
import PokemonPicker from './components/PokemonPicker';
import natureBg from './assets/nature-bg.svg';

function App() {
  const [gameState, setGameState] = useState(null);
  const [pickData, setPickData] = useState(null);
  const [disconnected, setDisconnected] = useState(false);

  useEffect(() => {
    document.documentElement.style.setProperty('--nature-bg', `url(${natureBg})`);
  }, []);

  useEffect(() => {
    socket.on('pick-phase', (data) => {
      setPickData(data);
    });

    socket.on('game-start', (data) => {
      setPickData(null);
      setGameState(data);
      setDisconnected(false);
    });

    socket.on('player-disconnected', () => {
      setDisconnected(true);
    });

    return () => {
      socket.off('pick-phase');
      socket.off('game-start');
      socket.off('player-disconnected');
    };
  }, []);

  const handleLeave = () => {
    setGameState(null);
    setPickData(null);
    setDisconnected(false);
  };

  if (gameState) {
    return (
      <Game
        gameState={gameState}
        disconnected={disconnected}
        onLeave={handleLeave}
      />
    );
  }

  if (pickData) {
    return <PokemonPicker pickData={pickData} />;
  }

  return <Lobby />;
}

export default App;
